import { getDataMapper, mapField } from "@/shared";

export const mapAmoCrmCredsToServer = getDataMapper({
    appId: mapField("appId", String),
    secret: mapField("secret", String),
    domain: mapField("domain", String),
    authToken: mapField("authToken", String),
});
